import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import css from 'page/CombineScreen/item/ItemCard.module.scss'
import { SelectedBadge } from 'page/CombineScreen/item/SelectedBadge'
import { useEffect, useRef } from 'react'
import { renderItemTitle } from 'shared/item/title'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { OfferItem } from 'type/rec'
import { formatCurrency } from 'util/currency'

type Props = {
  active: boolean
  index: number
  item: OfferItem
}

export const ItemCard = observer(({ active, index, item }: Props) => {
  const image = item.item_combo_image || item.item_full_image
  const title = renderItemTitle(item)
  const price = opt.prices ? formatCurrency(item.price, item.currency) : undefined
  const ref = useRef<HTMLDivElement>(null)

  const scroll = useLatestCallback(() => {
    if (active) {
      ref.current?.scrollIntoView({ inline: 'nearest' })
    }
  })

  useEffectOnce(() => {
    setTimeout(scroll, 100)
  })

  useEffect(() => {
    if (active) scroll()
  }, [active])

  const onSelect = useLatestCallback(() => {
    const currentItem = store.tempComboItem || store.item!
    currentItem.rec.index = index
  })

  return (
    <Vertical
      ref={ref}
      className={clsx(css.root, css.combo)}
      gap={12}
      width={100}
      onClick={onSelect}
    >
      <Space className={clsx(css.image, active && css.active)}>
        {image && <Image src={image} />}
      </Space>
      {active && <SelectedBadge anchorRef={ref} />}
      <Vertical gap={4}>
        {title}
        {price && <Typo size={12}>{price}</Typo>}
      </Vertical>
    </Vertical>
  )
})
